import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import 'antd/dist/reset.css'
import './index.css'
import './styles/common/index.css'  // Common TEC styles - must come after index.css
import './pages/directory/DirectoryPage.css'
import App from './App.tsx'
import PasswordResetConfirmPage from './pages/auth/PasswordResetConfirmPage'
import { initSentry } from './monitoring/sentry'

// Before the first render, so errors during startup are reported too (#338).
initSentry();

// Check if we're on a password reset confirm page (served by Django)
const passwordResetContext = (window as any).passwordResetContext;
const passwordResetCompleteContext = (window as any).passwordResetCompleteContext;

// Render appropriate component based on context
if (passwordResetContext || passwordResetCompleteContext) {
  // Password Reset pages (Django-served with window context)
  // Component will read from window.passwordResetContext
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <PasswordResetConfirmPage />
    </StrictMode>,
  );
} else {
  // Normal app routing (includes /reset-password/:uidb64/:token route)
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
